import Cookie from 'js-cookie';

export const setCookies = async (name, value) => {
  Cookie.set(name, value, {
    expires: 90,
    secure: true,
    sameSite: 'strict',
    path: '/',
  });
};

export const getCookies = (name) => Cookie.get(name);

export const removeCookie = (name) => Cookie.remove(name);
